import * as types from '../constants/actionTypes';
import {addNotification as notify} from 'reapop';
import * as vesselActions from "../graphql/actions/vessel";
import l10n from "../l10n/localization";
import * as creationActions from "./creation";
import * as ajaxRoutes from "../constants/ajaxRoutes";
import * as authHandler from "../utils/authHandler";


export function fetchVessels(force = false) {
    return dispatch => {
        dispatch(loading());
        vesselActions.getVessels(
            function(response) {
                dispatch(receiveVessels(response.data.vessels));
            },
            function(error) {
                dispatch(notify({message: error.message, status: 'error'}));
            },
            force
        );
    }
}

export function add(vessel) {
    return dispatch => {
        dispatch(loading());
        dispatch(saving(vessel));
        vesselActions.add(
            function (response) {
                dispatch(saved(response.data.createVessel));
                //dispatch(fetchVessels(true));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
                dispatch(creationActions.receivednewlyCreatedVessel(response.data.createVessel));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            vessel
        );
    };
}


export function edit(vessel) {
    let id = vessel.id;
    delete vessel.id;
    delete vessel.__typename;

    return dispatch => {
        dispatch(loading());
        dispatch(saving(vessel));
        vesselActions.edit(
            function (response) {
                dispatch(saved(response.data.editVessel));
                dispatch(fetchVessels(true));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            id,
            vessel
        );
    };
}

export function deleteVessel(vesselID) {
    return dispatch => {
        let url = ajaxRoutes.API_ROUTE + "/vessel/delete/"+vesselID;
        let headers = new Headers({"X-Authorization": 'Bearer ' + authHandler.getToken()});
        dispatch(deletingVessel());
        fetch(url, {headers: headers})
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                dispatch(notify({message: l10n.messages.removed, status: 'success'}));
                return response;
            })
            .then(() => {
                dispatch(doneDeletingVessel());
                dispatch(fetchVessels(true));
            })
            .catch((error) => {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(doneDeletingVessel());
            });
    };
}

export function deletingVessel(){
    return {
        type: types.DELETING_VESSEL
    };
}

export function doneDeletingVessel(){
    return {
        type: types.DONE_DELETING_VESSEL
    };
}


export function loading() {
    return {
        type: types.LOADING_VESSEL
    };
}


export function saving(vessel) {
    return {
        type: types.SAVING_VESSEL,
        payload: vessel
    };
}

export function saved(vessel) {
    return {
        type: types.SAVED_VESSEL,
        payload: vessel
    };
}

export function errorSaving() {
    return {
        type: types.ERROR_SAVING_VESSELS,
    };
}

export function receiveVessels(data) {
    return {
        type: types.RECEIVED_VESSELS,
        payload: data
    };
}

export function errorMessage(message) {
    return dispatch => {
        dispatch(notify({message: message, status: 'error',dismissAfter: 8000}));
    };
}



// WEBPACK FOOTER //
// ./src/actions/vessel.js